<template>
  <div class="preloader js-preloader">
    <div class="loader loader-inner-1">
      <div class="loader loader-inner-2">
        <div class="loader loader-inner-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreLoader",
};
</script>

<style lang="scss">
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--clr_white);
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  text-align: center;
  margin: 5px;
  border-radius: 50%;
  border: 4px solid var(--clr_redical);
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  transform-style: preserve-3d;
  position: relative;
}
.loader-inner-1 {
  animation-delay: 0.2s;
  animation: change_first_circle 4s ease-in-out infinite;
}
.loader-inner-2 {
  animation-delay: 0.2s;
  animation: change_second_circle 4s ease-in-out infinite;
}
.loader-inner-3 {
  animation-delay: 0.2s;
  width: 40px;
  height: 40px;
  animation: change_last_circle 4s linear infinite;
}
@keyframes change_first_circle {
  50% {
    transform: rotateX(360deg) scale(0.8);
  }
}
@keyframes change_second_circle {
  50% {
    transform: rotateY(360deg) scale(0.8);
  }
}
@keyframes change_last_circle {
  50% {
    transform: rotateX(360deg) scale(0.8);
  }
}
</style>